<template>
    <v-footer
        color="white"
        absolute
        app
    >
        <v-card
            color="transparent"
            width="100%"
            flat
            tile
        >
            <v-card-text class="caption ma-0 pa-2">
                <v-row
                    no-gutters
                    align="center"
                    justify="center"
                >
                    <v-card
                        @click="open('terms')"
                        :ripple="false"
                        flat
                    >
                        <v-card-text
                            v-text="translate('terms')"
                            class="ma-0 pa-0 caption"
                        />
                    </v-card>
                    <v-icon
                        v-text="'mdi-circle-small'"
                        small
                    />
                    <v-card
                        @click="openGdpr"
                        :ripple="false"
                        flat
                    >
                        <v-card-text
                            v-text="translate('gdpr')"
                            class="ma-0 pa-0 caption"
                        />
                    </v-card>

                    <v-icon
                        v-text="'mdi-circle-small'"
                        small
                    />
                    <div v-text="'TCB People and Organisation AB'" />
                    <v-icon
                        v-text="'mdi-copyright'"
                        class="px-1"
                        small
                    />
                    <div v-text="new Date().getFullYear()" />
                </v-row>
            </v-card-text>
        </v-card>
    </v-footer>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { locales_mixin } from '@/mixins/services/locales_mixin'

export default {
    name: 'TheFooter',
    props: {},
    mixins: [locales_mixin],
    components: {},
    data() {
        return {
            icons: ['mdi-facebook', 'mdi-twitter', 'mdi-linkedin', 'mdi-instagram'],
        }
    },
    computed: {
        ...mapGetters([]),
        ...mapState([]),
    },
    watch: {},
    methods: {
        open(dialog) {
            this.set_state_property({
                property: 'terms_and_condition_dialog',
                data: dialog,
            })
        },
        openGdpr() {
            window.open('/2025-10-15_gdpr_u2work.pdf', '_blank')
        },
        ...mapActions(['set_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
}
</script>
<style scoped></style>
